import RecommendationsUsers from './container';

export default RecommendationsUsers;



// WEBPACK FOOTER //
// ./src/routes/RecommendationsUsers/index.js